@if (technicalDocumentsList$ | async; as technicalDocumentsList) {
<div class="container p-0">
  <h2>{{ 'productDetails.specification' | cxTranslate }}</h2>
  <table>
    @for (feature of technicalDocumentsList; track feature) {
    <tr class="col-12 d-flex flex-wrap float-left">
      <td class="col-12 col-lg-4 col-md-4 col-sm-4 float-left text-capitalize">{{ feature.name }}</td>
      <td class="col-12 col-lg-8 col-md-8 col-sm-8 float-left">
        <ul [ngClass]="feature?.featureValues.length > 1 ? 'show-bulleted-list' : ''">
          @for (featureValue of feature?.featureValues; track featureValue) {
          <li>
            @if (isEncodedHtml(featureValue?.value)) {
            <div [innerHTML]="featureValue?.value"></div>
            } @if (!isEncodedHtml(featureValue?.value)) {
            <a [href]="featureValue?.value" target="_blank">
              {{ feature?.name === 'Spec Sheet' ? feature?.name + ' ' : '' }}
              {{ featureValue?.value | extractFilename }}
            </a>
            }
          </li>
          }
        </ul>
      </td>
    </tr>
    }
  </table>
</div>
}
